<template>
    <div class="animated fadeIn custom-cases bgV2">
        <div class="d-flex headerOrderDetail">
            <div class="orderNumber d-flex justify-content-between align-items-end pr-4 w-100">
                <div class="mt-20 pl-20">
                    <h1 class="mb-1">{{Item.job_number}}</h1>
                </div>
                <h4 class="c-orange mb-0" v-if="Item.id">{{Item.status}}</h4>
            </div>
        </div>
        <b-row>
            <b-col md="12">
                <gofix-tab
                    class="mt-3 contractPropertyTab"
                    :data="tabData">
                    <template slot="gofixTab:right">
                        <gofix-button class="mr-3" label="Safety Inspection Report" @click="reportJob"></gofix-button>
                        <gofix-button
                            v-if="isShowNextAction"
                            :disabled="!this.$checkRole(this.$accessModule.safety_inspection_checklist, 'update')"
                            class="mr-3" 
                            label="NEXT ACTION"
                            @click="changeStatus" outline>
                        </gofix-button>
                        <gofix-button
                            :disabled="!$checkRole(this.$accessModule.safety_inspection_checklist, 'update') || Item.status != 'New'"
                            :loading="loadingSave"
                            @click="updateData"
                            label="SAVE">
                        </gofix-button>
                    </template>
                    <template slot="gofixTab:basic-info">
                        <detail-info @reloadItem="getItem"></detail-info>
                        <!-- Content Checklist -->
                        <gofix-card :class="['position-relative mb-13 pt-16 px-24 pb-19', {'run-loading': loadingCheckListEntry }]" classHeader="mb-0 pd-0" classContent="pd-0 mb-0">
                            <b-row no-gutters>
                                <template v-for="(item, index) in tableItems">
                                    <b-col md="12" class="mb-13" :key="index" v-if="item.children.length == 0">
                                        <checklist-entries :job="Item" :section="item.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item"></checklist-entries>
                                    </b-col>
                                    <template v-else>
                                        <template v-for="(item1) in item.children">
                                        <b-col md="12" class="mb-13" :key="item1.id">
                                            <checklist-entries :job="Item" :section="item.name + ' >> ' + item1.name" @updateCheckListEntries="updateCheckListEntries" @selectChecklistEntry="selectChecklistEntry" @reloadChecklist="reloadChecklist" @inputType="isTyping = true" :item="item1"></checklist-entries>
                                        </b-col>
                                        </template>
                                    </template>
                                </template>
                            </b-row>
                        </gofix-card>
                        <signature :job="Item" v-if="Item && !Item.number_of_infringements"></signature>
                    </template>
                    <template slot="gofixTab:infringements">
                        <infringements @reloadItem="getItem"></infringements>
                        <signature :job="Item" v-if="Item.number_of_infringements && Item.number_of_infringements > 0"></signature>
                    </template>
                    <template slot="gofixTab:activity-log">
                        <activities ref="activities" activityType="Job Safety" :activityId="$route.params.id"></activities>
                    </template>
                </gofix-tab>
            </b-col>
        </b-row>
        <ModalRemarkFollowUp v-model="modals.remark.open" :item="modals.remark.checklistEntry" :job="Item" @reloadChecklist="reloadChecklist"/>
        <ModalNextAction v-model="modals.status.open"  :checklistEntries="tableItems" @reloadItem="getItem"/>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    const Activities = () => import("../activities")
    const DetailInfo = () => import("./detail-info")
    const checklistEntries = () => import("../detail-checklist")
    const Infringements = () => import("./detail-infringement")
    const Signature = () => import("../detail-signature")
    const ModalRemarkFollowUp = () => import("../modal_remark_follow_up")
    const ModalNextAction = () => import("./modal_next_action")
    export default {
        name: 'safety-inspection-checklist-detail',
        components: {
            DetailInfo,
            checklistEntries,
            Activities,
            Infringements,
            Signature,
            ModalRemarkFollowUp,
            ModalNextAction
        },
        data() {
            return {
                tabData:[
                    {
                        key: "basic-info",
                        title: "Basic Info",
                        active: true
                    },
                    {
                        key: "infringements",
                        title: "Infringements",
                        active: false
                    },
                    {
                        key: "activity-log",
                        title: "Activity Log",
                        active: false
                    }
                ],
                tableItems: [],
                loadingCheckListEntry: false,
                modals: {
                    status: {
                        open: false,
                        loading: false
                    },
                    approval_log: {
                        open: false,
                        loading: false
                    },
                    remark: {
                        open: false,
                        checklistEntry: null
                    },
                    status: {
                        open: false,
                    },
                },
                isModalShow: false,
                isTyping: false,
                isSave: false,
                checkListEntryUpdate: [],
                loadingSave: false,
                timer_save: null,
                timer_report: null,
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            isShowNextAction() {
                if(this.$checkRole(this.$accessModule.safety_inspection_checklist, 'update') && this.Item && this.Item.status != 'Completed') {
                    return true;
                }

                return false;
            }
        },
        watch: {
            Item: function() {
                this.getCheckListGroupData()
            },
            isTyping: function(val) {
                if(val === false && this.isSave === true) {
                    this.updateData();
                }
            }
        }, 
        mounted() {
            const _this = this;
            this.$root.$on('bv::modal::show', (bvEvent, modalId) => {
                if(modalId == 'msgConfirm') _this.isModalShow = true;
            })
            this.$root.$on('bv::modal::hide', (bvEvent, modalId) => {
                if(modalId == 'msgConfirm') _this.isModalShow = false;
            })
        },
        created() {
            if (
                !this.$route.params.hasOwnProperty("id") ||
                isNaN(this.$route.params.id)
            ) {
                return this.$router.push({
                    name: "safety-inspection-checklist-list"
                });
            }
            this.getItem()
        },
        methods: {
            /*-- Get Data --------*/
            getItem() {
                this.loadingDetail = true
                this.$store.dispatch( 'SafetyAppController/getSafetyInspectionChecklistItem', this.$route.params.id)
                .then(response => {
                    // this.item = Object.assign(this.item, response)
                    this.loadingDetail = false
                })
                .catch(err => {
                    console.log(err)
                    this.loadingDetail = false
                })
            },
            async getCheckListGroupData(){
                this.loadingCheckListEntry = true;
                await this.$store
                    .dispatch("SafetyAppController/getSafetyCheckListGroupData", this.$route.params.id)
                    .then((result) => {
                        this.tableItems = result.items;
                        this.loadingCheckListEntry = false;
                    })
                    .catch((err) => {
                        this.loadingCheckListEntry = false;
                });
            },
            reloadChecklist() {
                this.getCheckListGroupData();
            },
            async updateCheckListEntries(val){
                let params = val;
                let request = {
                    id: params.val.id,
                    value: params.val.input.value,
                    status: params.val.status,
                }
                if(params.val.hasOwnProperty('output')) request.output = params.val.output;
                if(params.val.hasOwnProperty('is_output_highlighted')) request.is_output_highlighted = params.val.is_output_highlighted;
                if(!params.from_status){
                    if(params.val.input.value){ request.status = params.val.status = 'Filled'; }
                    else{ request.status = params.val.status = 'Unfilled';}
                }

                let checkListEntryData = [request];
                if(this.checkListEntryUpdate.length > 0){
                    checkListEntryData = Object.assign([], this.checkListEntryUpdate);
                }
                let flag = false;
                if(checkListEntryData.length > 0){
                    for (let i = 0; i < checkListEntryData.length; i++) {
                        if (request && request.id == checkListEntryData[i].id) {
                            this.checkListEntryUpdate[i] = request;
                            flag = true;
                            break;
                        }
                    }
                    if(!flag){
                        this.checkListEntryUpdate.push(request);
                    }
                }
                this.isTyping = false;
            },
            selectChecklistEntry(entry) {
                this.modals.remark.checklistEntry = entry;
                this.modals.remark.open = true;
            },

            /*-- Store Data --------*/
            updateData() {
                if (this.timer_save) {
                    clearTimeout(this.timer_save);
                    this.timer_save = null;
                }
                this.timer_save = setTimeout(() => {
                    if(this.isTyping) {
                        this.isSave = true;
                        return;
                    }
                    if(this.isModalShow) return;
                    this.isSave = false;

                    var checkValidate = this.checkListEntryUpdate.filter(function(item) {
                        return (item.status === 'Filled' && !item.value);
                    });
                    if(checkValidate.length > 0){
                        return this.$alertNotification("Please enter checklist entries value when the status Filled", "danger");
                    }
                    this.loadingSave = true;
                    let request = {
                        array_data: JSON.stringify(this.checkListEntryUpdate),
                        job_id: this.Item.id
                    };
                    this.$store
                        .dispatch("SafetyAppController/updateCheckListJob", request)
                        .then(async (data) => {
                            // await this.getItem();
                            this.loadingSave = await false;
                            this.checkListEntryUpdate = [];
                            this.$alertNotification(this.$notificationV2("editing", "checklist"));
                        })
                        .catch((err) => {
                            this.$alertNotification("Can not update checklist!", "danger");
                        });
                }, 100);
            },
            reportJob() {
                if (this.timer_report) {
                    clearTimeout(this.timer_report);
                    this.timer_report = null;
                }
                this.timer_report = setTimeout(() => {
                    let nameFile = `${this.Item.job_number}.pdf`;
                    this.$store.dispatch("SafetyAppController/reportSafetyInspectionChecklistItem", this.Item.id)
                    .then(response => {
                        const url = window.URL.createObjectURL(new Blob([response.data]));
                        const link = document.createElement('a');
                        link.href = url;
                        link.setAttribute('download', nameFile);
                        document.body.appendChild(link);
                        link.click();
                    });
                }, 300);
            },
            changeStatus() {
                if(this.checkListEntryUpdate.length) {
                    return this.$alertNotification("Please press the 'Save' button to save the data checklist before changing the status for this Safety inspection.", "warning");
                }
                this.modals.status.open = true;
            },
        }
    }
</script>